import React from 'react';
import { connect } from 'react-redux';
import LockScreenForm from './components/LockScreenForm';

const Ava = `${process.env.PUBLIC_URL}/img/11.png`;

const LockScreen = ({ userData }) => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__profile">
          <img className="account__avatar" src={Ava} alt="" />
          <p className="account__name">{userData.fullName}</p>
          <p className="account__sub">Unlock your account</p>
        </div>
        <LockScreenForm onSubmit />
      </div>
    </div>
  </div>
);

export default connect((state) => ({ userData: state.user }))(LockScreen);
